
import React, { Fragment, useState } from 'react'
import {AppButton,AppRow,AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Icon ,Col} from 'antd';
import api, {PosAppProjectOutput} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : "00-01-02-03-04-05" ,
    formdata:{mac:''} ,
    labelWidth:100 ,
    items:
    [
        {lable:'mac',field:'mac',placeholder:'string类型，设备的MAC地址'},
    ]
};

let outputExample = [
    {id:1,name:'A项目'},
    {id:2,name:'B项目'}
] as PosAppProjectOutput[]

export const AppGetProject = () =>{

    const[outputResult,setOutputResult]  = useState(null as PosAppProjectOutput[])
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        let res = await api.posapp.getProject(inputParam);
        setOutputResult(res);
    }

    const renderOutput = () =>{
        console.log('outputResult:',outputResult)
        if(outputResult===null) return '';

        switch(outputView){
            case 0:
            return renderOutputProjectTable();
            case 1:
            return renderJson();
        }

        return '';
    }

    const renderOutputProjectTable = () =>{
        let list = null;
        if(outputResult && outputResult){
            list = outputResult
        }
        if(list){
            return ( <AppTable  dataSource={list}>
               <AppTable.ColIndex />
               <AppTable.Col field='id' title='id' width={100}/>
               <AppTable.Col field='name' title='name' />
            </AppTable>)
        }else{
            return null;
        }
       
    }
    const renderJson = () =>{
        return <pre>{JSON.stringify(outputResult, null, 4)}</pre>
    } 
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>PosApp获取项目列表</h1>    
            <div>
                1、Pos端登录后才能调用使用<br/>
                2、地址：/api/posapi/getProject <br/>
                3、get方式传值<br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['列表（projectList）','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/AppGetProject.tsx